<div class="trend-series-chart fw fh">
    <div class="chart-area fw fh"></div>
</div>